module.exports = __webpack_public_path__ + "static/e-fast-and-on-time-delivery-60046659309a331a505ce25d630964ae.png";